import { render, staticRenderFns } from "./FavouriteSearchFilters.vue?vue&type=template&id=a2ccf2e8&scoped=true&"
import script from "./FavouriteSearchFilters.vue?vue&type=script&lang=js&"
export * from "./FavouriteSearchFilters.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteSearchFilters.vue?vue&type=style&index=0&id=a2ccf2e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ccf2e8",
  null
  
)

export default component.exports